/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/promotions'>.
 * exact; render.ready[0][1]
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Promotions from '@routes/Promotions';

export const Route = createFileRoute('/promotions/')({
  component: () => <CacheDataRoute component={Promotions} path='/promotions' />
});
